import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/app/[locale]/error.tsx");
